// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".divider{height:.5px;width:100%;background-color:#e0e0e0;margin:12px 0}", ""]);
// Exports
module.exports = exports;
